import * as Intercom from "@utils/intercom";
import { logout as resetRudderClient } from "@utils/rudderstack";
import { Image } from "expo-image";
import { flipStoreReset } from "store/flip";
import { setUser } from "@utils/sentry";
import { clearStoredVendorAttempts } from "@components/Checkout/vendor/attemptStorage";
import type { DevicePorts } from "./ports";

export const nativeAccountCleanup: DevicePorts["accountCleanup"] = {
  clearDiskCache: () => Image.clearDiskCache(),
  clearMemoryCache: () => Image.clearMemoryCache(),
  logoutSupport: () => Intercom.logout(),
  resetAnalytics: resetRudderClient,
  resetFlip: flipStoreReset,
  clearVendorAttempts: clearStoredVendorAttempts,
  clearTelemetryUser: () => setUser(null),
};
